export default __webpack_public_path__ + "static/media/clock.f4b0dc78.svg";